import persistReducer from "redux-persist/es/persistReducer";
import storage from "redux-persist/lib/storage";
import { actionTypes } from "../../../Auth/_redux/authRedux";
import {
  CALL_CUSTOMER_STATUS_AGGREGATE,
  LONGEST_TIME_INFO,
  TOP_QUEUES
} from "../actions/customerStatusActions";

const intitialState = {
  liveCustomerStatusDetails: {
    topQueueCalls: {},
    longestTimeInfo: {},
    customerStatusAggregate: {},
  },
};
const getKeyName = () => {
  return process.env.REACT_APP_VERSION + "-customerStatus";
};

export const customerStatusReducer = persistReducer(
  {
    storage,
    key: getKeyName(),
    whitelist: [],
  },
  (state = intitialState, action) => {
    switch (action.type) {
      case TOP_QUEUES: {
        if (action.payload) {
          var customersStatusNewState = {
            ...state,
            liveCustomerStatusDetails: {
              ...state.liveCustomerStatusDetails,
              ...action.payload,
            },
          };
        }
        return customersStatusNewState;
      }
      case LONGEST_TIME_INFO: {
        if (action.payload) {
          var longestTimeDetails = {
            ...state,
            liveCustomerStatusDetails: {
              ...state.liveCustomerStatusDetails,
              ...action.payload,
            },
          };
        }
        return longestTimeDetails;
      }

      case CALL_CUSTOMER_STATUS_AGGREGATE: {
        if (action.payload) {
          var customerStatusNewState = {
            ...state,
            liveCustomerStatusDetails: {
              ...state.liveCustomerStatusDetails,
              ...action.payload,
            },
          };
        }
        return customerStatusNewState;
      }
      case actionTypes.Logout: {
        return intitialState;
      }
      default: {
        return state;
      }
    }
  }
);
